export const DATE_FORMAT = "DD.MM.YYYY";
export const SHORT_DATE_FORMAT = "DD.MM.YY";
export const DATE_TIME_FORMAT = "DD.MM.YYYY HH:mm";
